import React, { useState, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import NotificationAlert from "react-notification-alert";

import { Button, Row, Col, Card, Input, Modal, ModalBody } from "reactstrap";

import ReactInputMask from "react-input-mask";

import { format, addHours } from "date-fns";

import api from "../../services/api";
import formatPhoneString from "../../services/formatPhoneString";
import { FaPencilAlt } from "react-icons/fa";
function SmsPage() {
  const notificationAlert = useRef(null);

  const notify = (place, color, message) => {
    var options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>{message}</div>
        </div>
      ),
      type: color,
      icon: "now-ui-icons ui-1_bell-53",
      autoDismiss: 7,
    };
    notificationAlert.current.notificationAlert(options);
  };

  const [isOpenPhone, setIsOpenPhone] = useState(false);
  function togglePhone() {
    setIsOpenPhone(!isOpenPhone);
  }

  const [isOpenBirthday, setIsOpenBirthday] = useState(false);
  function toggleBirthday() {
    setIsOpenBirthday(!isOpenBirthday);
  }

  const [query, setQuery] = useState("");
  const [phoneEdit, setPhoneEdit] = useState("");
  const [birthdayEdit, setBirthdayEdit] = useState("");

  const [clients, setClients] = useState(null);
  const [client, setClient] = useState(null);
  const [expandedClients, setExpandedClients] = useState({});
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("@clube:token");

  const search = useCallback(async () => {
    if (query.trim().length < 4) {
      notify("tr", "danger", "Digite ao menos 4 caracteres para pesquisar.");
      return;
    }

    try {
      setLoading(true);
      const response = await api.get(
        `/admin/client/search/${encodeURIComponent(query.trim())}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setClients(response.data.clients);
      setClient(null);

      if (response.data.clients.length === 0) {
        notify("tr", "danger", "Nenhum cliente encontrado.");
      }
    } catch (err) {
      notify("tr", "danger", "Erro ao carregar informações.");
    } finally {
      setLoading(false);
    }
  }, [token, query]);

  const updateClientInList = useCallback((updated) => {
    setClients((prev) =>
      prev ? prev.map((c) => (c.id === updated.id ? updated : c)) : prev
    );
  }, []);

  const updatePhone = useCallback(async () => {
    if (phoneEdit !== "") {
      try {
        const newPhone = phoneEdit.replace(/\D/g, "");
        const response = await api.put(
          `/admin/client/${client.id}`,
          { phone: newPhone },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const updated = response.data;
        setClient(updated);
        updateClientInList(updated);
        togglePhone();
        notify("tr", "success", response?.data?.message || "Editado");
      } catch (err) {
        notify(
          "tr",
          "danger",
          err?.response?.data?.error || "Erro ao carregar informações."
        );
      }
    } else {
      notify("tr", "danger", "Digite um número válido.");
    }
  }, [token, client, phoneEdit, togglePhone, updateClientInList]);

  const updateBirthday = useCallback(async () => {
    try {
      const date = new Date(birthdayEdit);

      if (!date) {
        notify("tr", "danger", "Insira uma data válida");
        return;
      }

      const newBirthday = addHours(date, 12);

      const response = await api.put(
        `/admin/client/${client.id}`,
        { birthday: newBirthday },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const updated = response.data;
      setClient(updated);
      updateClientInList(updated);
      toggleBirthday();
      notify("tr", "success", response?.data?.message || "Editado");
    } catch (err) {
      notify(
        "tr",
        "danger",
        err?.response?.data?.error || "Erro ao carregar informações."
      );
    }
  }, [token, client, birthdayEdit, toggleBirthday, updateClientInList]);

  return (
    <>
      <NotificationAlert ref={notificationAlert} />
      <div className="content">
        <Row md="12">
          <Col md="8">
            <h3>Clientes</h3>
          </Col>
        </Row>

        <Row style={{ alignItems: "stretch" }}>
          <Col md="10">
            <Input
              name="search"
              placeholder="Buscar por telefone ou e-mail (mín. 4 caracteres)"
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && query.length >= 4 && search()}
              style={{ height: 48, fontSize: 15, borderRadius: 8 }}
            />
          </Col>
          <Col md="2">
            <Button
              color="success"
              onClick={search}
              disabled={query.length < 4}
              style={{ height: 48, width: "100%", borderRadius: 8, fontSize: 15, margin: 0 }}
            >
              Pesquisar
            </Button>
          </Col>
        </Row>

        {clients !== null && clients.length === 0 && !loading && (
          <p style={{ marginTop: 16 }}>Nenhum cliente encontrado.</p>
        )}

        {loading && (
          <>
            <style>{`
              @keyframes shimmer {
                0% { background-position: -600px 0; }
                100% { background-position: 600px 0; }
              }
              .skeleton-box {
                background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
                background-size: 600px 100%;
                animation: shimmer 1.4s infinite linear;
                border-radius: 6px;
              }
            `}</style>
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                style={{
                  marginTop: 16,
                  borderRadius: 12,
                  border: "1px solid #e8e8e8",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                  overflow: "hidden",
                }}
              >
                <div style={{ padding: "16px 24px", borderBottom: "1px solid #f0f0f0", background: "#fafafa" }}>
                  <div className="skeleton-box" style={{ height: 22, width: "40%" }} />
                </div>
                <div style={{ padding: "16px 24px" }}>
                  <div style={{ display: "flex", gap: 24 }}>
                    {[1, 2, 3].map((j) => (
                      <div key={j} style={{ flex: 1 }}>
                        <div className="skeleton-box" style={{ height: 11, width: "60%", marginBottom: 8 }} />
                        <div className="skeleton-box" style={{ height: 16, width: "80%" }} />
                      </div>
                    ))}
                  </div>
                  <div style={{ marginTop: 16, paddingTop: 14, borderTop: "1px solid #f0f0f0" }}>
                    <div className="skeleton-box" style={{ height: 11, width: 90, marginBottom: 8 }} />
                    <div style={{ display: "flex", gap: 6 }}>
                      {[1, 2].map((j) => (
                        <div key={j} className="skeleton-box" style={{ height: 24, width: 100, borderRadius: 20 }} />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </>
        )}

        {!loading && clients && clients.map((c) => (
          <Card
            key={c.id}
            style={{
              marginTop: 16,
              borderRadius: 12,
              border: "1px solid #e8e8e8",
              boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <div style={{ padding: "16px 24px", borderBottom: "1px solid #f0f0f0", background: "#fafafa" }}>
              <p style={{ margin: 0, fontSize: 18, fontWeight: 700, color: "#1a1a1a", letterSpacing: "-0.3px" }}>
                {c.name}
              </p>
            </div>

            {/* Body */}
            <div style={{ padding: "16px 24px" }}>
              <Row>
                <Col md="4">
                  <p style={{ margin: "0 0 2px", fontSize: 11, fontWeight: 600, color: "#999", textTransform: "uppercase", letterSpacing: "0.6px" }}>Telefone</p>
                  <p style={{ margin: 0, fontSize: 14, color: "#333", display: "flex", alignItems: "center", gap: 6 }}>
                    {formatPhoneString(c.phone)}
                    <FaPencilAlt
                      onClick={() => { setClient(c); togglePhone(); }}
                      style={{ color: "#0dcaf0", cursor: "pointer", fontSize: 12 }}
                    />
                  </p>
                </Col>
                <Col md="4">
                  <p style={{ margin: "0 0 2px", fontSize: 11, fontWeight: 600, color: "#999", textTransform: "uppercase", letterSpacing: "0.6px" }}>E-mail</p>
                  <p style={{ margin: 0, fontSize: 14, color: c.email ? "#333" : "#bbb", fontStyle: c.email ? "normal" : "italic" }}>
                    {c.email || "Não informado"}
                  </p>
                </Col>
                <Col md="4">
                  <p style={{ margin: "0 0 2px", fontSize: 11, fontWeight: 600, color: "#999", textTransform: "uppercase", letterSpacing: "0.6px" }}>Aniversário</p>
                  <p style={{ margin: 0, fontSize: 14, color: "#333", display: "flex", alignItems: "center", gap: 6 }}>
                    {c.birthday ? format(new Date(c.birthday), "dd/MM/yyyy") : <span style={{ color: "#bbb", fontStyle: "italic" }}>Não informado</span>}
                    <FaPencilAlt
                      onClick={() => { setClient(c); toggleBirthday(); }}
                      style={{ color: "#0dcaf0", cursor: "pointer", fontSize: 12 }}
                    />
                  </p>
                </Col>
              </Row>

              {c.client && c.client.length > 0 && (
                <div style={{ marginTop: 16, paddingTop: 14, borderTop: "1px solid #f0f0f0" }}>
                  <p style={{ margin: "0 0 8px", fontSize: 11, fontWeight: 600, color: "#999", textTransform: "uppercase", letterSpacing: "0.6px" }}>Restaurantes</p>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                    {(expandedClients[c.id] ? c.client : c.client.slice(0, 3)).map((cs) => (
                      <Link
                        key={cs.store_id}
                        to={`/stores/${cs.store_id}`}
                        style={{ textDecoration: "none" }}
                      >
                        <span
                          style={{
                            background: "#f0faf4",
                            border: "1px solid #b7e4c7",
                            color: "#2d6a4f",
                            borderRadius: 20,
                            padding: "3px 12px",
                            fontSize: 12,
                            fontWeight: 500,
                            cursor: "pointer",
                            display: "inline-block",
                          }}
                        >
                          {cs.store?.fantasy_name || cs.store?.name}
                        </span>
                      </Link>
                    ))}
                    {c.client.length > 3 && !expandedClients[c.id] && (
                      <span
                        onClick={() => setExpandedClients((prev) => ({ ...prev, [c.id]: true }))}
                        style={{
                          background: "#f5f5f5",
                          border: "1px solid #ddd",
                          color: "#666",
                          borderRadius: 20,
                          padding: "3px 12px",
                          fontSize: 12,
                          fontWeight: 500,
                          cursor: "pointer",
                        }}
                      >
                        +{c.client.length - 3}
                      </span>
                    )}
                    {c.client.length > 3 && expandedClients[c.id] && (
                      <span
                        onClick={() => setExpandedClients((prev) => ({ ...prev, [c.id]: false }))}
                        style={{
                          background: "#f5f5f5",
                          border: "1px solid #ddd",
                          color: "#666",
                          borderRadius: 20,
                          padding: "3px 12px",
                          fontSize: 12,
                          fontWeight: 500,
                          cursor: "pointer",
                        }}
                      >
                        −
                      </span>
                    )}
                  </div>
                </div>
              )}
            </div>
          </Card>
        ))}

        <Modal isOpen={isOpenPhone} toggle={togglePhone}>
          <ModalBody style={{ padding: 28 }}>
            <p style={{ margin: "0 0 4px", fontSize: 11, fontWeight: 600, color: "#999", textTransform: "uppercase", letterSpacing: "0.6px" }}>
              Editar telefone
            </p>
            <p style={{ margin: "0 0 20px", fontSize: 18, fontWeight: 700, color: "#1a1a1a" }}>
              {formatPhoneString(client?.phone)}
            </p>
            <ReactInputMask
              mask="(99) 99999-9999"
              onChange={(e) => setPhoneEdit(e.target.value)}
            >
              {() => (
                <Input
                  name="phone_edit"
                  placeholder="Novo número"
                  type="text"
                  style={{ height: 44, fontSize: 15, borderRadius: 8, marginBottom: 16 }}
                />
              )}
            </ReactInputMask>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
              <Button color="secondary" outline onClick={togglePhone} style={{ borderRadius: 8 }}>
                Cancelar
              </Button>
              <Button color="success" onClick={updatePhone} style={{ borderRadius: 8 }}>
                Salvar
              </Button>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={isOpenBirthday} toggle={toggleBirthday}>
          <ModalBody style={{ padding: 28 }}>
            <p style={{ margin: "0 0 4px", fontSize: 11, fontWeight: 600, color: "#999", textTransform: "uppercase", letterSpacing: "0.6px" }}>
              Editar aniversário
            </p>
            <p style={{ margin: "0 0 20px", fontSize: 18, fontWeight: 700, color: "#1a1a1a" }}>
              {client?.name}
            </p>
            <Input
              name="new_birthday"
              type="date"
              onChange={(e) => setBirthdayEdit(e.target.value)}
              lang="pt-BR"
              style={{ height: 44, fontSize: 15, borderRadius: 8, marginBottom: 16 }}
            />
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
              <Button color="secondary" outline onClick={toggleBirthday} style={{ borderRadius: 8 }}>
                Cancelar
              </Button>
              <Button color="success" onClick={updateBirthday} style={{ borderRadius: 8 }}>
                Salvar
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
}

export default SmsPage;
